module.exports = __webpack_public_path__ + "img/ione6.5a1ac965.png";